import moment from 'moment'
import 'moment-timezone'

const systemTimezone = process.env.VUE_APP_API_SYSTEM_TIMEZONE

const DateTimeUtils = {
  convertToDatabaseTime (input) {
    return moment(input).format('YYYY-MM-DD HH:mm:ss')
  },
  convertToUTC (input) {
    return moment(input).utc().format()
  },
  convertTimeZoneToUTC (input, timezone) {
    return moment.tz(input, timezone).utc().format()
  },
  convertUTCToLocal (input) {
    return moment.utc(input).local().format()
  },
  convertUTCToTimeZone (input, timezone) {
    return moment.utc(input).tz(timezone).format()
  },
  convertToTimeZone (input, timezone = systemTimezone) {
    return moment(input).tz(timezone).format()
  },
  convertTimeZoneToLocal (input, timezone) {
    return moment.tz(input, timezone).local().format()
  },
  convertTimeZoneToTimeZone (input, timezoneSource, timezoneDest) {
    return moment.tz(input, timezoneSource).tz(timezoneDest).format()
  },
  formatDisplay (input, format = '') {
    return moment(input).format(format)
  },
  dateDisplay (input, dayFirst = true) {
    return dayFirst ? moment(input).format('DD/MM/YYYY') : moment(input).format('YYYY/MM/DD')
  },
  dateWeekDisplay (input, dayFirst = true) {
    return dayFirst ? moment(input).format('DD/MM/YYYY (dddd)') : moment(input).format('YYYY/MM/DD (dddd)')
  },
  dateDisplayHK (input, week = false) {
    return week ? moment(input).format('LL （dddd）') : moment(input).format('LL')
  },
  dateTimeDisplay (input, dayFirst = true) {
    return dayFirst ? moment(input).format('DD/MM/YYYY hh:mm A') : moment(input).format('YYYY/MM/DD hh:mm A')
  },
  dateTimeFormatDisplay (input, format = 'DD/MM/YYYY hh:mm A') {
    return moment(input).format(format)
  },
  dateTimeDisplayHK (input, dayFirst = true) {
    return dayFirst ? moment(input).format('LL hh:mm A') : moment(input).format('LL hh:mm A')
  },
  dateTimeRangeDisplay (start, end) {
    start = this.convertTimeZoneToLocal(start, systemTimezone)
    end = this.convertTimeZoneToLocal(end, systemTimezone)
    if (moment(start).isSame(end, 'day')) {
      return this.dateTimeDisplay(start) + ' - ' + this.formatDisplay(end, 'hh:mm A')
    }
    return this.dateTimeDisplay(start) + ' - ' + this.dateTimeDisplay(end)
  },
  weekDisplay (input) {
    return moment(input).format('dddd')
  },
  monthDisplay (input) {
    return moment().month(input - 1).format('MMMM')
  },
  timeDisplay (input, timezone = '', hour12 = true) {
    return hour12 ? moment(input).tz(timezone).format('hh:mm A') : moment(input).tz(timezone).format('HH:mm')
  },
  relativeTimeDisplay (input) {
    let output = moment(input).fromNow() // 1.11 sec
    // make output dont have decimal point
    const outputArr = output.split(' ')
    if (outputArr.length > 1) {
      if (outputArr[0].indexOf('.') > -1) {
        outputArr[0] = outputArr[0].split('.')[0]
        output = outputArr.join(' ')
      }
    }

    return output
  },
  infoDisplay (input) {
    return moment(input).format('LLL dddd') + ' [ ' + moment(input).fromNow() + ' ]'
  },
  infoTimeDisplay (input) {
    return moment(input).format('hh:mm A') + ' [ ' + moment(input).fromNow() + ' ]'
  },
  addBracket (input, zh = true) {
    return input ? zh ? '（' + input + '）' : '(' + input + ')' : input
  }
}
export default DateTimeUtils
